import React, { useState, useEffect } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import apiService from '../../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import MenuVerDiagnosticos from './MenuVerDiagnosticos';
import ButtonsMenu from '../../Utils/ButtonsMenu';
import { FaFile } from 'react-icons/fa';
import { useAuth } from '../../../Auth/AuthContext';

export default function DiagPerdidasOtras(){
    const { token } = useAuth();
    const navigate = useNavigate();
    const [Cargando, setCargando] = useState(false);
    const [datosPerdidasOtras, setDatosPerdidasOtras] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10); 
    const [swalProps, setSwalProps] = useState();
    useEffect(() => {
        fetchData(currentPage, perPage);
    }, [currentPage, perPage]);
    const fetchData = async (page, rowsPerPage) => {
        const url = `/caracterizacion/diagnosticos/listardatoperdidasotras?page=${page}&limit=${rowsPerPage}`;
        try {
            setCargando(true);
            const response = await apiService.get(url, token);
            const result = await response.data;
            setDatosPerdidasOtras(result.data);
            setTotalRows(result.meta.total);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
        
        
    };
    function verAtencionesPersonas (row, verAtencionesPersona){
        return (<button id={row.per_idpersona} type="button" onClick={() => verAtencionesPersona(row)} 
                        style={{backgroundColor: 'skyblue'}} 
                        data-tooltip-id='tooltiparriba'
                        data-tooltip-content="Ver atenciones de la persona"
                        aria-label="Ver atenciones de la persona">
                        <FaFile/>
                </button>   
        );
    }
    const columns = [
        {
            name: 'Acciones',
            cell: row => verAtencionesPersonas(row, verAtencionesPersona),
            ignoreRowClick: true,
            width: '3%'
        },
        { name: 'Identificación Cabeza', selector: row => row.idpersona, sortable: true, width:'11%' },
        { name: 'Nombre', selector: row => row.nombre, sortable: true, width: '20%'},
        { name: 'Tipo de Pérdida', selector: row => row.bien, sortable: true, width: '15%'},
        { name: 'Descripcón', selector: row => row.descripcion, sortable: true, width: '20%' },
        { name: 'Cantidad', selector: row => row.cantidad, sortable: true, width: '10%' },
        { name: 'Costo', selector: row => row.valor, sortable: true, width: '10%' }
    ];
    function verAtencionesPersona (row){
        navigate(`/consulta/consultaatenciones/${row.per_idpersona}`);
    };
    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setCurrentPage(page);
        fetchData(page, newPerPage);
    };
    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchData(page, perPage);
      };
    async function exportarCSV() {
        setCargando(true);
        const url = `/caracterizacion/diagnosticos/listardatoperdidasotras?page=0&limit=0&csv=true`;

        try {
            const response = await apiService.get(url, token, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download', 'datos_perdidas_otras.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }   
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Diagnostico perdidas (otras)</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to="/" >Inicio</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to="/consultas/verdiagnosticos" >Diagnosticos</NavLink></li>
                        <li className="breadcrumb-item active"> Perdidas otras</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuVerDiagnosticos />
                    <div className="row">
                        <div className="col-md-12">
                            <ButtonsMenu data={datosPerdidasOtras} titulo={'Informe Datos Perdidas Otras'} exportarCSV={exportarCSV}/>
                            <div className="card-body table-responsive p-0">
                                <DataTable
                                    title="Perdida (otros)"
                                    columns={columns}
                                    data={datosPerdidasOtras}
                                    progressPending={Cargando}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalRows}
                                    paginationPerPage={perPage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    onChangePage={handlePageChange}
                                    noDataComponent="No hay datos para mostrar"
                                /> 
                            </div>
                        </div>
                    </div>
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}